import { render, staticRenderFns } from "./CustomerAccessRequest.vue?vue&type=template&id=117e267d&"
import script from "./CustomerAccessRequest.vue?vue&type=script&lang=ts&"
export * from "./CustomerAccessRequest.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerAccessRequest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports